import imagekitMedia from "./imagekitMedia.json";

export const mediaUrl = (path) => imagekitMedia[path] || path;
